<template>
  <div class="entrance" @mouseover="qrcodeCard" @mouseleave="qrcodeCards">
    <div class="title"><img src="../assets/images/peoples.png">{{ info.title }}</div>
  </div>

  <el-card class="box-card" v-show="show">
    <div class="text item">
      <img src="../assets/images/wap_qrcode.png" />
    </div>
  </el-card>
</template>
<script>
export default ({
  name: "Entrance",
  data(){
    return {
      show: false
    }
  },
  props: {
    info: {
      type: Object,
      default() {
        return {
          title:"学员入口",
        }
      }
    }
  },
  computed: {},
  methods: {
    qrcodeCard: function() {
      //alert('ssss');
      this.show = true;
      //console.log();
    },
    qrcodeCards: function() {
      //alert('ssss');
      this.show = false;
      //console.log();
    }
  }
})
</script>

<style scoped>
.entrance {
  width: 365px;
  height: 60px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #E3E3E3;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.title {
  /* width: 300px; */
  height: 60px;
  float: left;
  line-height: 60px;
  color: #BC0000;
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.title img{
  width: 50px;
  height: 30px;
  margin: 0 15px;
}
.more .el-link {
  float: left;
  width: 65px;
  line-height: 60px;
  font-size: 14px;
  color: #9E9E9E;
  display: flex;
  height: 25px;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  border-bottom: 3px solid #E3E3E3;
}
.el-card {
  position: absolute;
  top: -210px;
  width: 200px;
  height: 200px;
  display: flex;
  right: 10px;
  flex-direction: row;
  justify-content: center;
}
.el-card img {
  width: 160px;
  height: 160px;
}
</style>